__turbopack_context__.v({
  "emphasis": "founder-quote-module-scss-module__8TymSW__emphasis",
  "icon": "founder-quote-module-scss-module__8TymSW__icon",
  "info": "founder-quote-module-scss-module__8TymSW__info",
  "lit": "founder-quote-module-scss-module__8TymSW__lit",
  "name": "founder-quote-module-scss-module__8TymSW__name",
  "photo": "founder-quote-module-scss-module__8TymSW__photo",
  "quote": "founder-quote-module-scss-module__8TymSW__quote",
  "role": "founder-quote-module-scss-module__8TymSW__role",
  "section": "founder-quote-module-scss-module__8TymSW__section",
  "stage": "founder-quote-module-scss-module__8TymSW__stage",
  "sticky": "founder-quote-module-scss-module__8TymSW__sticky",
  "tag": "founder-quote-module-scss-module__8TymSW__tag",
  "textCol": "founder-quote-module-scss-module__8TymSW__textCol",
  "word": "founder-quote-module-scss-module__8TymSW__word",
});
